module.exports = __webpack_public_path__ + "343ac8bb3542a6578f2a4cbaf0f99679.pdf";